<template>
  <div class="coefficient-per-day-accommodation">
    <b-row>
      <b-col cols="11">
        <PmwHeading
          size="paragraph-60"
          weight="weight-medium"
          class="form--title"
        >
          Coeficiente por dia da semana
        </PmwHeading>
      </b-col>

      <b-col class="remove-col" cols="1">
        <button
          class="remove-col--btn"
          @click="$emit('closeCoefficientPerDay', $event)"
        >
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>

    <div class="form--row">
      <PmwFormInput
        v-for="day in sortedDays"
        v-model.number="day.coeficiente"
        :key="`day-${day.diaSemana}`"
        :label="weekdays[day.diaSemana]"
        :required="showCoefficientPerDay"
        :error="
          errors.includes(`coeficienteDiasSemana[${day.diaSemana}].coeficiente`)
        "
        :data-error="`coeficienteDiasSemana[${day.diaSemana}].coeficiente`"
        type="number"
        placeholder="100"
        sufix="%"
        class="form--input"
      />
    </div>
  </div>
</template>

<script>
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'

import { getWeekDays } from '@/helpers/date'

export default {
  name: 'CoefficientPerDay',
  components: {
    PmwFormInput,
    PmwHeading
  },

  props: {
    /** Valores dos inputs por dia */
    initialValues: {
      type: Array,
      default: () => []
    },

    value: {
      type: Array,
      default: () => []
    },

    showCoefficientPerDay: {
      type: Boolean,
      default: false
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      weekdays: getWeekDays()
    }
  },

  computed: {
    sortedDays() {
      return this.sortDays(this.value)
    }
  },

  methods: {
    sortDays(arr) {
      return arr.sort((a, b) => a.diaSemana - b.diaSemana)
    }
  }
}
</script>

<style scoped lang="scss">
.coefficient-per-day-accommodation {
  border: 1px solid pmw-colors(grey-20);
  padding: 12px 21px;

  .remove-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    &--btn {
      @include reset-button();

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }
  .form {
    &--title {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
      line-height: 21px;
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 18px;
    }

    &--input {
      width: 100px;

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }
  }
}
</style>
